import type { SVGProps } from 'react';

export const ShieldLefthalfFilledSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16.8555 20.3496"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="20.3496" opacity="0" width="16.8555" x="0" y="0" />{' '}
        <path
          d="M0 12.1158C0 15.6785 1.95449 17.0732 7.56289 20.1473C7.81855 20.2822 8.075 20.3496 8.24706 20.3496C8.41913 20.3496 8.68359 20.2822 8.93124 20.1473C14.5476 17.0812 16.4941 15.6785 16.4941 12.1158L16.4941 4.733C16.4941 3.57578 16.0459 3.16739 15.0769 2.7543C13.9914 2.30215 10.3322 1.01524 9.26776 0.651758C8.94432 0.548048 8.57499 0.480666 8.24706 0.480666C7.91914 0.480666 7.54981 0.565822 7.23438 0.651758C6.16992 0.955666 2.50273 2.31016 1.41718 2.7543C0.45625 3.15938 0 3.57578 0 4.733ZM8.41699 18.2652L8.41699 2.34237C8.508 2.35038 8.60175 2.3787 8.75722 2.42909C10.0648 2.94296 12.8523 3.93593 14.3238 4.45351C14.591 4.55468 14.6584 4.70019 14.6584 5.04452L14.6584 11.751C14.6584 14.6367 13.2254 15.4119 8.81035 18.0752C8.6498 18.1799 8.52714 18.2412 8.41699 18.2652Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
